module.exports = __webpack_public_path__ + "img/10.f90080ed.png";